import React, { Component } from "react";
import { connect } from "react-redux";
import QRCode from "react-qr-code";
import AuthCode from "react-auth-code-input";
import {
  generateOneTimePasswordSecret,
  validateOneTimePasswordConfiguration,
  deleteOneTimePasswordSecret,
} from "../../../services/Management/UserProfileService";
import defaultLogo from "../../../assets/logos/Logo-Oasis.svg";
import Paths from "../../../constants/Paths";
import { signIn2FA, signoutUser } from "../../../actions/UserActions";

class InitialSetup extends Component {
  state = {
    generatedSecretKeyAuthUrl: "",
    generatedSecretKey: "",
    twoFACode: "",
    hasError: false,
  };

  componentDidMount() {
    generateOneTimePasswordSecret({ IsSelfReset: false }).then((res) => {
      if (res != null) {
        this.setState({ generatedSecretKeyAuthUrl: res.otpAuthUrl });
        this.setState({ generatedSecretKey: res.secretKey });
      }
    });
  }

  cancelConfiguration() {
    deleteOneTimePasswordSecret();
    signoutUser();
  }

  updateTwoFACode = (code) => {
    this.setState({ hasError: false });
    this.setState({ twoFACode: code });
  };

  validateOneTimePasswordMatches() {
    validateOneTimePasswordConfiguration({
      oneTimePassword: this.state.twoFACode,
    }).then((res) => {
      this.setState({ hasError: !res });
      if (res) {
        this.props.updateSetupCompleteAndVerified();
      }
    });
  }

  render() {
    const { _ } = this.props;
    const twoFACodeValid = this.state.twoFACode.length === 6;

    return (
      <div className="login-screen forgot-password reset-password">
        <div className="login-screen-form-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="twoFA-initial-setup-left-panel col-md-5 px-3 py-2">
                <div>
                  <img
                    src={defaultLogo}
                    alt={_.Logo}
                    className="login-screen-logo px-3 py-3"
                  />
                </div>
                <div className="twoFA-explanation-setup">
                  <div>
                    <h4>Two-Factor Authentication Setup</h4>
                  </div>
                  <div className="twoFA-initial-setup">
                    <div className="twoFAuth-setup-instruction-text">
                      Your Site Administrator has enabled a security policy
                      which requires all users to use Two-Factor Authentication
                      alongside their login credentials to access this site.
                      Please follow the instructions on this page to configure
                      your mobile device.
                    </div>
                  </div>
                </div>
                <p className="login-screen-footer-copyright">
                  {_.FooterCopyright}
                </p>
              </div>
              <div className="col-md-7 p-0">
                <div className="twoFAuth-code-management-setup">
                  <h4>Setup Required</h4>
                  <div className="twoFA-initial-setup">
                    <div className="twoFAuth-qr-code-zone-setup">
                      <div className="qr-code-setup">
                        {this.state.generatedSecretKeyAuthUrl.length > 0 && (
                          <QRCode
                            value={this.state.generatedSecretKeyAuthUrl}
                            style={{
                              height: "100%",
                              width: "100%",
                              maxWidth: "100%",
                            }}
                          />
                        )}
                        <div className="instruction-text-setup">
                          {_.TwoFAuth.SidebarMenu.QRCodeInstructions}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="twoFAuth-manual-secret-input-text">
                    {_.TwoFAuth.SidebarMenu.SecretKeyInstructions}
                  </div>
                  <div className="twoFAuth-secret-zone-setup">
                    <div className="secret-code">
                      <span className="icon lock-icon icon-omni-lock" />
                      {this.state.generatedSecretKey}
                    </div>
                  </div>
                  <form>
                    <div className="instruction-text-setup">
                      {_.TwoFAuth.SidebarMenu.EnterCode}
                    </div>
                    <div className="input-container-setup">
                      <AuthCode
                        containerClassName="input-container-setup"
                        inputClassName={
                          "input-code-setup" +
                          (this.state.hasError ? "-with-error" : "")
                        }
                        allowedCharacters="numeric"
                        length={6}
                        onChange={(e) => this.updateTwoFACode(e)}
                      />
                    </div>
                    <div className="button-area">
                      <button
                        type="submit"
                        className="btn twoFAuth-confirm-btn-themed-setup form-control"
                        disabled={!twoFACodeValid || this.state.hasError}
                        onClick={(e) => {
                          e.preventDefault();
                          this.validateOneTimePasswordMatches();
                        }}
                      >
                        {_.Confirm}
                      </button>
                    </div>
                    <div>
                      <p className="cancel-link">
                        <a
                          href={Paths.Login}
                          onClick={() => {
                            this.cancelConfiguration();
                          }}
                        >
                          {_.Cancel}
                        </a>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;
const mapActionsToProps = {
  signIn2FA,
  //signoutUser,
};
export default connect(mapStateToProps, mapActionsToProps)(InitialSetup);
